import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxCollection,
  RxDocument,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const userSchemaLiteral = {
  title: 'User Schema',
  description: 'Describes a user',
  version: 2,
  keyCompression: false,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    name: {
      type: 'string',
    },
    email: {
      type: 'string',
    },
    roles: {
      type: 'array',
      items: {
        type: 'string',
      },
    },
  },
  required: ['id', 'name'],
  indexes: [],
} as const

export const userMigrationStrategies = {
  1: (oldDoc: any) => ({
    ...oldDoc,
    roles: [],
  }),
  2: (oldDoc: any) => ({
    ...oldDoc,
    email: '',
  }),
}

const schemaTyped = toTypedRxJsonSchema(userSchemaLiteral)

export type UserDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>

export const userSchema: RxJsonSchema<UserDocType> = schemaTyped

export type UserDocMethods = {
  test: () => void
}

export type UserDocument = RxDocument<UserDocType, UserDocMethods>

export type UserCollectionMethods = {
  test: () => void
}

export type UserCollection = RxCollection<UserDocType, UserDocMethods, UserCollectionMethods>
